import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const RedirectToPost = () => {
  const { id } = useParams(); // Get the id from the URL params
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the desired route and replace the current history entry
    navigate(`/p/${id}`, { replace: true });
  }, [id, navigate]);

  return null; // This component doesn't render anything
};

export default RedirectToPost;